import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import AdminSidebar from '../components/AdminSidebar';
import { Link } from 'react-router-dom';
import './MonitorChatList.css';

const AdminMonitorChatList = () => {
  const [chatIds, setChatIds] = useState([]);

  useEffect(() => {
    const fetchChats = async () => {
      const chatsSnapshot = await getDocs(collection(db, 'chats'));
      const ids = chatsSnapshot.docs.map(doc => doc.id);
      setChatIds(ids);
    };

    fetchChats();
  }, []);

  return (
    <div className="admin-page">
      <AdminSidebar />
      <div className="monitor-chat-list">
        <h2>🗂️ جميع المحادثات</h2>
        <ul>
          {chatIds.map((id) => (
            <li key={id}>
              <Link to={`/admin/monitor/${id}`}>عرض المحادثة: {id}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AdminMonitorChatList;
